<template>
  <div class="new-link-wrap">
    <el-dialog title="新增链接" append-to-body :visible.sync="myVisible" :modal-append-to-body="false" width="850px" height="530px"
      style="margin-top:4vh;" class="add-label-dialog" :close-on-click-modal="false">
      <div>
        <div class="row">
          <span class="required">*</span>
          <span class="label" >标题</span>
          <div>
            <slot name="value">
              <template>
                <el-input
                  type="text"
                  placeholder="请输入链接标题"
                  v-model="form.title"
                  maxlength="30"
                  size="small"
                  show-word-limit
                  style="width:310px;"
                >
                </el-input>
              </template>
            </slot>
          </div>
        </div>
        <div class="row">
          <span class="required">*</span>
          <span class="label" >链接地址</span>
          <div>
            <slot name="value">
              <template>
                <el-input
                  type="text"
                  placeholder="请输入以http或https开头的链接地址"
                  v-model="form.httpUrl"
                  :maxlength="128"
                  size="small"
                  show-word-limit
                  style="width:310px;"
                >
                </el-input>
              </template>
            </slot>
          </div>
        </div>
        <div class="row" v-if="myType != 3">
          <span class="required" style="color: white;">*</span>
          <span class="label" >使用场景</span>
          <div>
            <slot name="value">
              <template>
                <el-input type="textarea" id="myTextarea" style="width:310px;" ref="myTextarea" clearable v-model="form.content" autocomplete="off"
                placeholder="请输入副标题" size="small" :maxlength="50" show-word-limit ></el-input>
              </template>
            </slot>
          </div>
        </div>
        <div class="row">
          <span class="required">*</span>
          <span class="label" >缩略图</span>
          <div class="value-wrap">
            <slot name="value">
              <template>
                <el-upload
                  ref="uploadLink"
                  class="avatar-uploader"
                  :action="sendUrl"
                  accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PBG,"
                  :headers="headers"
                  :show-file-list="false"
                  :on-error="onError"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload">
                  <i v-if="!form.pictureUrl" class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <div v-if="form.pictureUrl" class="avatar-wrap">
                  <img  class="avatar" :src="form.fileFullUrl" />
                  <div class="close-wrap" @click="deletePhoto()"><span class="el-icon-close close-icon"></span></div>
                </div>
                <span class="tip">允许上传2M内的图片(jpg/png/jpeg)</span>
              </template>
            </slot>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small " @click="myVisible = false" style="margin-right:20px">取 消</el-button>
        <el-button type="primary" size="small" :disabled="btnDisable" @click="confirmWeicome()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "newLink",
  components: {
  },
  props: {

  },
  data() {
    return {
      myVisible: false,
      myType: 1,
      form: {
        title: '',
        httpUrl: '',
        content: '',
        pictureUrl: '',
        pictureName: '',
        fileFullUrl:''
      },
      headers: {
        authorization: ''
      },
      imageUrl: '',
      sendUrl: this.$baseUrl + '/api/chatMaterial/uploadFile',
      loading: null
    };
  },
  created() {
    this.headers.authorization = localStorage.getItem("Authorization");
  },
  watch: {
  },
  computed: {
    btnDisable() {
      let flag = true
      if(this.form.title && this.form.httpUrl && this.form.pictureUrl) {
        flag = false
      }
      return flag
    }
  },
  methods: {
    show(form,myType) {
      this.form = form
      this.myType = myType
      this.myVisible = true
    },
    handleAvatarSuccess(res, file) {
      this.loading.close()
      this.form.pictureUrl = res.data.url
      this.form.fileFullUrl = res.data.fileFullUrl
      this.form.pictureName = res.data.name
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if(['image/jpeg','image/png','image/jpg'].indexOf(file.type) == -1) {
        this.$message.error('上传图片只能是 JPG 、PNG、JPG 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
        return false
      }
      this.loading = this.$loading({
        lock: true,
        text: '拼命上传中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      return true
    },
    onError(err) {
      this.loading.close()
      this.$message.error('上传失败，请重试！')
      console.log('err',err)
    },
    deletePhoto() {
      this.form.pictureUrl = ''
      this.form.fileFullUrl = ''
      this.form.pictureName = ''
      this.$refs.uploadLink.uploadFiles.splice(0, 1)
    },
    // 确定
    confirmWeicome() {
      let Expression=/http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
      let objExp=new RegExp(Expression);
      console.log(objExp.test(this.form.httpUrl));
      if(objExp.test(this.form.httpUrl)){
        this.$emit('comfirm',this.form)
        this.myVisible = false
      }else{
        this.$message.error('链接地址需以http://或https://为开头，请重新输入');
      }
    }
  }
};
</script>
<style lang="scss" scoped>
 /deep/ .el-dialog {
  // min-height: 504px;
}
/deep/.el-dialog__header {
  padding: 28px 32px 20px;
  .el-dialog__title {
    font-size: 16px;
    font-weight: bold;
  }
}
/deep/ .el-dialog__body {
  padding: 0px 24px 20px 32px;
}
/deep/ .el-dialog__footer{
  text-align: right;
  padding: 0 26px 20px;
}
.row {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  .required {
    color: #FF4B59;
    margin-right: 5px;
    transform: translate(0, 2px);
  }
  .label {
    margin-right: 15px;
    font-size: 14px;
    font-weight: bold;
    width: 4em;
    text-align-last:justify;
    text-align:justify;
    text-justify:distribute-all-lines;
  }
  .value-wrap {
    display: flex;
    align-items: flex-end;
    .tip {
      color: #959595;
      font-size: 12px;
      margin-left: 11px;
    }
  }
  /deep/ .avatar-uploader {
    display: flex;
  }
  /deep/.avatar-uploader .el-upload {
    display: block;
    
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  /deep/.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  /deep/.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    width: 79px;
    height: 76px;
    line-height: 76px;
    text-align: center;
  }
  .avatar-wrap {
    width: 81px;
    height: 78px;
    display: block;
    position: relative;
    .avatar {
      width: 100%;
      height: 100%;
    }
    .close-wrap {
      position: absolute;
      top: -6px;
      right: -6px;
      border-radius: 50%;
      width: 13px;
      height: 13px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      cursor: pointer;
      background-color: #FF5E6A;
      .close-icon {
        color: white;
      }
    }
  }
  /deep/ .el-input__inner {
    padding: 0 8px;
    font-size: 14px;
  }
  .el-input__inner::placeholder {
    color: #999999;
    font-size: 14px;
    font-weight: unset;
  }
    /* 谷歌 */
  .el-input__inner::-webkit-input-placeholder {
    color: #999999;
    font-size: 14px;
    font-weight: unset;
  }
    /* 火狐 */
  .el-input__inner:-moz-placeholder {
    color: #999999;
    font-size: 14px;
    font-weight: unset;
  }
    /*ie*/
  .el-input__inner:-ms-input-placeholder {
    color:#999999;
    font-size: 14px;
    font-weight: unset;
  }
  /deep/ .el-textarea__inner {
    min-height: 76px !important;
    padding: 8px;
    // border: none;
    resize: none !important;
  }
}
</style>